import Select, { SelectProps } from 'antd/lib/select';
import { BUSINESS_SEGMENT_VALUES } from 'src/domain/pjm/values';

export function BusinessSegmentSelector(props: SelectProps) {
    const options = BUSINESS_SEGMENT_VALUES.map(it => ({ label: it, value: it }));

    return (
        <Select
            showSearch
            autoClearSearchValue
            optionFilterProp="label" // to search by label not value
            placeholder="Select Business Segment"
            options={options}
            {...props}
        />
    );
}
